module.exports = function getLowercaseUserName(user) {
    let user_name

    // only doing this since typeof array is 'object'. cmon, don't be stupid
    if (user instanceof Array) {
        throw new Error('user must be an object, string, or undefined')
    }

    switch (typeof user) {
        case 'object':
            user_name = (user && user.user_name) || ''
            break
        case 'string':
            user_name = user
            break
        default:
            user_name = ''
    }

    return user_name.toLowerCase()
}
